import React from 'react';

const SettingsLayout = ({ 
  sidebar, 
  children, 
  title = "Settings", 
  description = "Configure review automation and application preferences" 
}) => {
  return (
    <div className="max-w-full mx-auto p-6">
      {/* Page Header */}
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-3xl font-bold text-text-primary mb-2">
              {title}
            </h1>
            <p className="text-text-secondary">
              {description}
            </p>
          </div>
        </div>
      </div>

      {/* Two-column layout */}
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Column - Sidebar */}
        <div className="lg:w-64 flex-shrink-0">
          {sidebar}
        </div>

        {/* Right Column - Content */}
        <div className="flex-1 min-w-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout; 